import { Record } from 'immutable';
import { makeReducer, match } from 'web-app/util/redux';
import * as Actions from './actions';
export class ChildCheckOutState extends Record({
    isCheckingOut: false,
}) {
}
export default makeReducer([
    match(Actions.checkOutChild, state => state.merge({
        isCheckingOut: true,
    })),
    match(Actions.checkOutChildSuccess, state => state.merge({
        isCheckingOut: false,
    })),
    match(Actions.checkOutChildFailed, state => state.merge({
        isCheckingOut: false,
    })),
], new ChildCheckOutState());
